var bambo = {},
    e = e || {};
( function () {
    'use strict';
    jQuery( function () {
        bambo.init();
    } );
    bambo.init = function () {
        bambo.stepguide.init();
        if ( jQuery( '#PopupModal' ).length ) {
            bambo.plugin.popupCookie.init();
        }
    };
    bambo.plugin = {};
    bambo.plugin.popupCookie = {
        check: function () {
            var jId = jQuery( '#PopupModal' ).data( 'id' ).toString();
            if ( jQuery.cookie( 'popupCookie' ) !== jId ) {
                jQuery( '.modal-popup' ).on( 'hide', function () {
                    jQuery.cookie( 'popupCookie', jId, {
                        expires: 30
                    } );
                } ).modal();
            }
        },
        init: function () {
            this.check();
        }
    };
    bambo.stepguide = {
        onSiteLoad: function () {
            var cookieSet = jQuery.cookie( 'currentStep' ),
                currentStepNumber = 0,
                lastStepNumber = jQuery( '.steplist' ).find( 'a' ).length;
            if ( cookieSet !== null ) {
                currentStepNumber = parseInt( cookieSet );
            }
            else {
                currentStepNumber = 1;
                jQuery.cookie( 'currentStep', 1 );
            }
            if ( currentStepNumber !== lastStepNumber ) {
                jQuery( 'button.next-filter' ).show();
            }
            else {
                jQuery( 'button.last-filter' ).show();
            }
            jQuery( '.steplist' ).find( 'a[data-step="' + currentStepNumber + '"]' ).addClass( 'active' );
            jQuery( '.steplist-content' ).find( 'li[data-step="' + currentStepNumber + '"]' ).show();
            jQuery( 'button.next-filter' ).data( 'nextstep', currentStepNumber + 1 );
        },
        toggle: function () {
            jQuery( '.steplist' ).find( 'a' ).on( 'click', function () {
                var stepNumber = jQuery( this ).data( 'step' );
                jQuery.cookie( 'currentStep', stepNumber );
                jQuery( '.e-productlist-filters' ).find( 'form' ).trigger( 'submit' );
            } );
            jQuery( 'button.next-filter' ).on( 'click', function ( event ) {
                var nextstepNumber = jQuery( this ).data( 'nextstep' );
                event.preventDefault();
                jQuery( '.steplist' ).find( 'a[data-step="' + nextstepNumber + '"]' ).trigger( 'click' );
            } );
        },
        resetAll: function () {
            jQuery( 'a.reset-all-filters' ).on( 'click', function () {
                jQuery.cookie( 'currentStep', null );
            } );
        },
        init: function () {
            this.onSiteLoad();
            this.toggle();
            this.resetAll();
        }
    };





}() );
